import styled from 'styled-components';

export const StudentInfoContainer = styled.div`
  display: flex;
  position: relative;

  @media (max-width: 1500px) and (min-width: 769px), (max-width: 1024px) {
    flex-direction: column;
    width: 100%;
  }
  h2 {
    margin-top: 20px;
  }
  .formElementContainer {
    .formElementHeader {
      font-weight: bold;
      margin-top: 20px;
      margin-bottom: 5px;
    }
  }
`;

export const StudentImage = styled.img`
  max-width: 200px;
  max-height: 250px;

  @media (max-width: 1500px) {
    margin-left: 8px;
  }
`;

export const TableContainer = styled.div`
  padding: 0 20px;
  tbody {
    cursor: pointer;
  }
`;
